<template>
  <div>
    <h2 class="m-2">
      CONTROL DE ENVÍO
    </h2>

    <v-card class="mb-5">
      <v-card-text>
        <v-row align="center">
          <v-col
            cols="12"
            sm="6"
            md="3"
          >
            <v-text-field
              v-model="filters.fecha"
              label="Fecha"
              type="date"
              outlined
              dense
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
          >
            <v-select
              v-model="filters.comercio"
              :items="comercioOptions"
              label="Comercio"
              outlined
              dense
              hide-details
              clearable
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
          >
            <v-select
              v-model="filters.motorizado"
              :items="motorizados"
              label="Motorizado"
              outlined
              dense
              hide-details
              clearable
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
          >
            <v-select
              v-model="filters.estatus"
              :items="estatuces"
              label="Estatus"
              outlined
              dense
              hide-details
              clearable
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :items-per-page="10"
        :loading="loading"
        class="elevation-1"
      >
        <template #[`item.fecha_orden`]="{ item }">
          {{ item.fecha_orden ? $moment(item.fecha_orden).utc().format('DD-MM-YYYY') : '' }}
        </template>
        <template #[`item.total`]="{ item }">
          C$ {{ item.total ? Number(item.total).toFixed(2) : '0.00' }}
        </template>
        <template #[`item.estado`]="{ item }">
          <v-chip
            small
            :color="getStatusColor(resolveStatus(item.estado))"
            dark
          >
            {{ resolveStatus(item.estado) }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      filters: {
        fecha: null,
        comercio: null,
        motorizado: null,
        estatus: null,
      },
      headers: [
        { text: 'ID', value: 'id' },
        {
          text: 'Fecha',
          value: 'fecha_orden',
          width: '130px',
        },
        { text: 'Comercio', value: 'nombreCliente' },
        { text: 'Punto A', value: 'puntoA' },
        { text: 'Punto B', value: 'puntoB' },
        { text: 'Motorizado', value: 'nombreDriver' },
        { text: 'Flete', value: 'total' },
        { text: 'Estatus', value: 'estado' },
      ],
      items: [],
      estatuces: ['En espera', 'En proceso', 'Finalizada', 'Anulada'],
    }
  },
  computed: {
    motorizados() {
      const drivers = this.items.map(item => item.nombreDriver).filter(Boolean)

      return [...new Set(drivers)]
    },
    comercioOptions() {
      const clients = this.items.map(item => item.nombreCliente).filter(Boolean)

      return [...new Set(clients)]
    },
    filteredItems() {
      return this.items.filter(item => {
        const itemFecha = item.fecha_orden ? this.$moment(item.fecha_orden).utc().format('YYYY-MM-DD') : ''
        const itemStatus = this.resolveStatus(item.estado)

        return (!this.filters.fecha || itemFecha === this.filters.fecha)
          && (!this.filters.comercio || item.nombreCliente === this.filters.comercio)
          && (!this.filters.motorizado || item.nombreDriver === this.filters.motorizado)
          && (!this.filters.estatus || itemStatus === this.filters.estatus)
      })
    },
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      try {
        this.loading = true
        const res = await this.$store.dispatch('get', { path: 'ordenes/getAllFull/' })
        if (res && res.length > 0) {
          this.items = res.map(item => ({
            ...item,
            puntoA: item.puntos_mapa?.find(p => p.nombre === 'A')?.direccion || 'N/A',
            puntoB: item.puntos_mapa?.find(p => p.nombre === 'B')?.direccion || 'N/A',
          }))
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error('Error fetching orders', error)
      }
    },
    resolveStatus(estado) {
      const e = Number(estado)
      if (e === 0) return 'En espera'
      if (e > 0 && e < 99) return 'En proceso'
      if (e === 99) return 'Finalizada'
      if (e === -99) return 'Anulada'

      return 'N/A'
    },
    getStatusColor(status) {
      switch (status) {
        case 'Finalizada': return 'success'
        case 'En proceso': return 'info'
        case 'Anulada': return 'error'
        case 'En espera': return 'warning'
        default: return 'grey'
      }
    },
  },
}
</script>

<style scoped>
.m-2 {
  margin: 1rem !important;
}

.mb-5 {
  margin-bottom: 2rem !important;
}
</style>
